import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource/syncopate/latin-400.css'
import '@fontsource/syncopate/latin-700.css'
import '@fontsource-variable/space-grotesk/wght.css'
import App from './App'
import './styles.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
